import { SVGProps, memo } from 'react';

function PencilIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={19}
      height={18}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="pencilIcon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7723 0.869141C14.5054 0.869141 14.2496 0.975805 14.0618 1.1654L14.0606 1.16666L12.7243 2.5029L15.4239 5.23176L17.4709 3.17784L15.4827 1.1654C15.2949 0.975862 15.0391 0.869141 14.7723 0.869141ZM11.9315 2.23508C11.9227 2.24387 11.9144 2.25299 11.9067 2.2624L1.29652 12.8726C1.24845 12.9206 1.21435 12.9809 1.19787 13.0468L0.107872 17.4093C0.0759416 17.5371 0.113403 17.6723 0.206558 17.7654C0.299714 17.8586 0.434901 17.896 0.562688 17.864L4.92519 16.7728C4.99143 16.7562 5.0519 16.7219 5.10005 16.6735L15.6867 6.03058L15.6885 6.02877L15.6888 6.02845L15.6914 6.02583L18.5274 3.18015L16.0156 0.63759C15.6869 0.305803 15.2393 0.119141 14.7723 0.119141C14.3056 0.119141 13.8582 0.305554 13.5296 0.636926L11.9315 2.23508ZM14.8947 5.76326L12.1953 3.0345L2.47079 12.759L5.21063 15.4988L14.8947 5.76326ZM4.68171 16.0305L1.94046 13.2893L1.90032 13.3294L0.987006 16.9848L4.64193 16.0705L4.68171 16.0305Z"
        fill="#222222"
      />
    </svg>
  );
}
export default memo(PencilIcon);
